import React, { useContext } from 'react';
import { Tabs } from 'antd';
import TamuSaran from './TamuSaran';
import TamuVerif from './TamuVerif';
import { UserContext } from '../../../context/UserContext';

const LihatTamu = () => {
  const [user] = useContext(UserContext);

  const { TabPane } = Tabs;

  function callback(key) {}

  return (
    <div>
      <div className='container-content'>
        <div className='container-detail' style={{ paddingTop: '5px' }}>
          <Tabs defaultActiveKey='1' onChange={callback}>
            <TabPane tab='Tamu' key='1'>
              <h1 className='table-title'>TAMU TERVERIFIKASI</h1>
              <TamuVerif />
            </TabPane>
            <TabPane tab='Saran Tamu' key='2'>
              <h1 className='table-title'>SARAN TAMU</h1>
              <TamuSaran />
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default LihatTamu;
